// extracted by mini-css-extract-plugin
export default {"wrapper":"branding_wrapper__hlI-z","menu":"branding_menu__g5BbM","preview":"branding_preview__1uZTG"};